module.exports = __webpack_public_path__ + "static/media/UserIcon.5275dd23.svg";